module.exports = __webpack_public_path__ + "static/media/further_maths.d91301bd.png";